module.exports = __webpack_public_path__ + "assets/img/boy@3x.9ea46fff.png";